import * as React from "react";
import { List, ArrayField, Datagrid, SingleFieldList, ChipField, TextField, EmailField, EditButton, DeleteButton } from 'react-admin';

export const ExternalList = props => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="_id" />
      <TextField source="label" />
      <EmailField source="email" />
      <ArrayField source="rules">
        <SingleFieldList>
          <ChipField source="title" />
        </SingleFieldList>
      </ArrayField>
      <TextField source="response_type" />
      <EditButton basePath="/externals" />
      <DeleteButton basePath="/externals" />
    </Datagrid>
  </List>
);
